import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const securityquestionlist = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-security-question-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const UpdateSecurityCode = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-update-security-pin`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const SendOTPForSecurityPin = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-send-otp-for-security-code`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const havesecuritypin = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-have-security-code`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const verifySecurityCode = (PIN) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-validate-security-code?PIN=${PIN}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



